import { BaseService } from './base'
import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'

class InspectionTask {
    list(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(`${APIPath.inspectionTask}?${params}`)
    }

    remove(id) {
        return BaseService.post(`${APIPath.inspectionTask}/${id}/remove`)
    }

    add(data) {
        return BaseService.post(`${APIPath.inspectionTask}`, data)
    }

    update(data) {
        return BaseService.post(`${APIPath.inspectionTask}`, data)
    }

    bulkRemove(data) {
        return BaseService.postExact(`${APIPath.inspectionTask}/RemoveBulk`, data)
    }

    scheduleTask(data) {
        return BaseService.post(`${APIPath.scheduleTask}`, data)
    }

    isScheduleByWeekEnabled() {
        return BaseService.get(`${APIPath.scheduleByWeekEnabled}`)
    }

    scheduleByWeek(data) {
        return BaseService.post(`${APIPath.scheduleByWeek}`, data)
    }

    /** Reserved for when backend adds GET Task/ScheduleByWeek (currently returns 405). */
    getScheduleByWeek(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        const suffix = params ? `?${params}` : ''
        return BaseService.get(`${APIPath.scheduleByWeek}${suffix}`)
    }

    getScheduleTask(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(`${APIPath.addScheduleTask}?${params}`)
    }

    updateSchedule(data) {
        return BaseService.put(`${APIPath.updateScheduleTask}`, data)
    }

    async removeSchedule(id) {
        try {
            console.log('Calling removeSchedule with ID:', id)
            const response = await BaseService.remove(
                `${APIPath.removeScheduleTask}/${id}`,
            )
            console.log('API Response:', response)
            return response
        } catch (error) {
            console.error('Error in removeSchedule:', error?.response || error)
            throw error
        }
    }
}

const InspectionTaskService = new InspectionTask()
Object.freeze(InspectionTaskService)
export { InspectionTaskService }
